// import bd_flag from "../../../assets/icons/bd_flag.ico";
import convertBDTimeToLocal from "../../utils/convertBDTimeToLocal";
export default function TajweedSchedule() {
  const courseSchedules = {
    level0: [{ activity: "ক্লাস", day: "Monday", time: "16:00" }],
    level1: [{ activity: "ক্লাস", day: "Tuesday", time: "15:30" }],
    level2: [{ activity: "ক্লাস", day: "Thursday", time: "19:00" }],
    level3: [{ activity: "ক্লাস", day: "Thursday", time: "21:30" }],
  };

  return (
    <section className="my-24">
      <div className="flex items-center">
        <span className="text-xl">ক্লাসের সময়ঃ </span>

        <span className="ml-3">
          আপনার স্থানীয় সময় ({Intl.DateTimeFormat().resolvedOptions().timeZone})
          অনুযায়ী
        </span>
      </div>
      <div className="my-10 py-10 bg-sky-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">সহজ তাজউইদ কোর্স - লেভেল ০</p>
          <p className=""> সপ্তাহে ১ দিন</p>
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {courseSchedules.level0.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>

                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="my-10 py-10 bg-green-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">সহজ তাজউইদ কোর্স - লেভেল ১</p>
          <p className=""> সপ্তাহে ১ দিন</p>
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {courseSchedules.level1.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="my-10 py-10 bg-violet-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">সহজ তাজউইদ কোর্স - লেভেল ২</p>
          <p className=""> সপ্তাহে ১ দিন</p>
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {courseSchedules.level2.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="my-10 py-10 bg-rose-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">সহজ তাজউইদ কোর্স - লেভেল ৩</p>
          <p className=""> সপ্তাহে ১ দিন</p>
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {courseSchedules.level3.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
